import gql from "graphql-tag"
import { DashBoardTable } from "../../../backend/src/common/dashboard/dashboardTable"

export class DashBoardTableStream extends DashBoardTable {
    apollo = null
    constructor(apollo, periods, tables, accountingPeriodId, customAmounts={}) {
        super(periods, tables, accountingPeriodId, customAmounts)
        this.apollo = apollo
    }

    async streamCustomAmount(key, value) {
        if (value === undefined || value === null) {
            debugger // git-ignore
            return

        }
        const result = await this.apollo.mutate({
            mutation: gql`
                mutation (
                    $accountingPeriodId: ID!,
                    $key: String!,
                    $value: Float!
                ) {
                    streamCustomAmount(
                        data: {
                            accountingPeriodId: $accountingPeriodId,
                            key: $key,
                            value: $value
                        }
                    )
                    {
                        success
                    }
                }
            `,
            variables: {
                accountingPeriodId: this.accountingPeriodId,
                key: key,
                value: value
            }
        });
        return result.data.success
    }

    async removeStreamCustomAmount(key) {
        const result = await this.apollo.mutate({
            mutation: gql`
                mutation (
                    $accountingPeriodId: ID!,
                    $key: String!
                ) {
                    removeStreamCustomAmount(
                        data: {
                            accountingPeriodId: $accountingPeriodId,
                            key: $key
                        }
                    )
                    {
                        success
                    }
                }
            `,
            variables: {
                accountingPeriodId: this.accountingPeriodId,
                key: key
            }
        });
        return result.data.success
    }

    async resetAllStreamCustomAmounts() {
        const result = await this.apollo.mutate({
            mutation: gql`
                mutation (
                    $accountingPeriodId: ID!
                ) {
                    resetAllStreamCustomAmounts(
                        data: {
                            accountingPeriodId: $accountingPeriodId
                        }
                    )
                    {
                        success
                    }
                }
            `,
            variables: {
                accountingPeriodId: this.accountingPeriodId
            }
        });
        return result.data.success
    }

}
